<script>
import Multiselect from "@/components/RMultiselect.vue";
import api from "../../services/api";

/**
 * Nav-bar Component
 */
export default {
  components: {Multiselect},
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      relations: {
        exhibitions: {
          data: []
        },
        sleeves: {
          data: []
        },
        persons: {
          data: []
        },
        sets: {
          data: []
        },
        technics: {
          data: []
        },
        types: {
          name: 'drawing_types',
          data: []
        },
        numerisations: {
          name: 'drawing_numerisations',
          data: []
        }
      },
    };
  },
  beforeMount() {
    for (const i in this.relations) {
      const name = this.relations[i].name ?? i;

      if (sessionStorage.getItem(name)) {
        this.relations[i].data = JSON.parse(sessionStorage.getItem(name));
        continue;
      }

      api.get(name).then((response) => {
        this.relations[i].data = response.data.data;
        sessionStorage.setItem(name, JSON.stringify(this.relations[i].data));
      });
    }
  },
  methods: {
    async submitForm() {
      api.save('drawings', this.model).then((response) => {
        if (response.status !== 200)
          this.$emit('error');
        else
          this.$emit('submitted');
      }).catch(() => {
        this.$emit('error');
      });
    },
    formatSelectListPersons(person) {
      return `${person.last_name} ${person.first_name}`
    }
  }
};
</script>

<template>
  <b-form>
    <b-tabs justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
      <b-tab active>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">Général</span>
        </template>
        <b-card no-body class="mb-2 pt-2">
          <b-card-body class="p-0">
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Numero inventaire" label-for="formrow-NumeroInv-input">
                  <b-form-input id="formrow-NumeroInv-input" type="text"
                                v-model="model.number"></b-form-input>
                </b-form-group>
              </b-col>

              <b-col>
                <b-form-group label="Format" label-for="formrow-format-input">
                  <b-form-input id="formrow-format-input" type="text"
                                v-model="model.format"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Date" label-for="formrow-date-input">
                  <b-form-input id="formrow-date-input" type="text" v-model="model.date"></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Exposition" label-for="formrow-exhibition-input">
                  <multiselect
                      id="formrow-exhibition-input"
                      v-model="model.exhibition"
                      :options="relations.exhibitions.data"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Nom de la pochette" label-for="formrow-sleeve-input">
                  <multiselect
                      id="formrow-sleeve-input"
                      v-model="model.sleeve"
                      :options="relations.sleeves.data"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Titre" label-for="formrow-observations-input">
                  <b-form-textarea id="formrow-observations-input" type="text"
                                   v-model="model.caption"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Annotations" label-for="formrow-observations-input">
                  <b-form-textarea id="formrow-observations-input" type="text"
                                   v-model="model.annotations"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Commentaire" label-for="formrow-observations-input">
                  <b-form-textarea id="formrow-observations-input" type="text"
                                   v-model="model.comment"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Copyright" label-for="formrow-copyright-input">
                  <b-form-textarea id="formrow-copyright-input" type="text"
                                   v-model="model.copyright"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">Personnes</span>
        </template>
        <b-card no-body class="mb-2 pt-2">
          <b-card-body class="p-0" title="">
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Présentes" label-for="formrow-personnes-input">
                  <multiselect
                      id="formrow-personnes-input"
                      v-model="model.persons"
                      :options="relations.persons.data"
                      label="last_name"
                      track-by="id"
                      select-label=""
                      :multiple="true"
                      :custom-label="formatSelectListPersons"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Auteur" label-for="formrow-auteur-input">
                  <multiselect
                      id="formrow-auteur-input"
                      v-model="model.authors"
                      :options="relations.persons.data"
                      label="last_name"
                      track-by="id"
                      select-label=""
                      :multiple="true"
                      :custom-label="formatSelectListPersons"
                      :show-labels="false"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>

      <b-tab>
        <template v-slot:title>
          <span class="d-none d-sm-inline-block">Technique</span>
        </template>
        <b-card no-body class="mb-2 pt-2">
          <b-card-body class="p-0">
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Serie" label-for="formrow-set-input">
                  <multiselect
                      id="formrow-sets-input"
                      v-model="model.sets"
                      :options="relations.sets.data"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                      :multiple="true"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Type" label-for="formrow-format-input">
                  <multiselect
                      id="formrow-format-input"
                      v-model="model.types"
                      :options="relations.types.data"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                      :multiple="true"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Technique" label-for="formrow-support-input">
                  <multiselect
                      id="formrow-support-input"
                      v-model="model.technics"
                      :options="relations.technics.data"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                      :multiple="true"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
              <b-col>
                <b-form-group label="Numérisation" label-for="formrow-numerisation-input">
                  <multiselect
                      id="formrow-numerisation-input"
                      v-model="model.numerisations"
                      :options="relations.numerisations.data"
                      label="name"
                      track-by="id"
                      :show-labels="false"
                      :multiple="true"
                  >
                  </multiselect>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mb-3">
              <b-col>
                <b-form-group label="Constat d'état" label-for="formrow-state_report-input">
                  <b-form-textarea id="formrow-state_report-input" type="text" v-model="model.state"></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-tab>
    </b-tabs>


    <div class="text-right">
      <b-button variant="primary" @click="submitForm">Enregistrer</b-button>
      <b-button variant="secondary" @click="$emit('cancel')">Annuler</b-button>
    </div>
  </b-form>
</template>